import posterApi from '@api/poster'
import { dGet } from '@core/utils'
import { action, computed, observable } from 'mobx'
import {
  getPosterByKey,
  gotoPoster,
  isStoreAccount,
  statisticPoster
} from '@util'
import { getCookie, setCookie } from '@hlj/hlj-utils'
import moment from 'moment'
/**
 * pop_up_frequency (弹窗频率，0:不配置 1:有效时间 2:每日 3:每周 4:每月)
 * pop_up_time (弹窗次数)
 */
const FREQUENCY = {
  '2': 'day',
  '3': 'week',
  '4': 'month'
}
class Store {
  @observable banner = {}

  // 商家首页弹窗
  @observable popupVisible = false
  @observable popupPoster = {}

  // 首页右侧浮窗
  @observable rightFloatVisible = false
  @observable rightFloatPoster = {}

  // 营销应用
  @observable marketingPosters = []

  // 首页右上角活动
  @observable topRightBannerPoster = {}

  @action
  getPosterData = async () => {
    const { data } = await posterApi.poster(5001)
    const realData = data || {}

    this.handleMarketingPosters(realData)
    this.handleTopBanner(realData)
    this.handleHomePopup(realData)
    this.handleRightFloat(realData)
    this.handleTopRightbanner(realData)
  }

  @action
  handleMarketingPosters = data => {
    const KEY = isStoreAccount()
      ? 'FRANCHISEE_MARKETING_APPLICATION_WINDOW'
      : 'MARKETING_APPLICATION_WINDOW'
    const holes = dGet(data, `floors.${KEY}.holes`, [])
    const option = hole => hole.posters
    this.marketingPosters = holes.filter(option).map(option)
  }

  @action
  handleTopBanner = data => {
    const holes = dGet(data, 'floors.Merchant_TOP_Banner.holes', [])

    holes.forEach(({ posters }) => {
      if (posters) {
        this.banner = posters

        const { id, image_path } = this.banner || {}

        if (image_path) {
          statisticPoster(id, 'element_view')
        }
      }
    })
  }

  @action
  handleHomePopup = data => {
    this.popupPoster = getPosterByKey(data, 'WEB_MERCHANT_HOME_POPUP')
    this.popupVisible = this.setVisible(this.popupPoster, 'special')
  }

  @action
  handleRightFloat = data => {
    this.rightFloatPoster = getPosterByKey(data, 'WEB_MERCHANT_FLOATING_WINDOW')
    this.rightFloatVisible = this.setVisible(this.rightFloatPoster)
  }

  @action
  handleTopRightbanner = data => {
    this.topRightBannerPoster = getPosterByKey(
      data,
      'SITE_MERCHANT_TOP_RIGHT_BANNER'
    )

    const { image_path, id } = this.topRightBannerPoster
    if (image_path) {
      statisticPoster(id, 'element_view')
    }
  }

  setVisible = (poster, flag) => {
    //若没有设置弹窗，接口还是会返回holes字段，poster参数是空对象
    if (flag && poster.image_path) {
      const current_time = moment().format(__FMT1__)
      const last_pop_up_time = getCookie(`last_pop_up_time${poster.id}`)
      if (last_pop_up_time) {
        const frequency = poster['pop_up_frequency']
        let times = getCookie(`click_times${poster.id}`) || 0
        if (frequency == '0') {
          //不设置，每次都弹
          statisticPoster(poster.id, 'element_view')
          return true
        } else if (frequency == '1') {
          //有效期内，设置的次数为几次就弹几次
          if (times < poster['pop_up_time']) {
            statisticPoster(poster.id, 'element_view')
            return true
          } else {
            return false
          }
        } else {
          //每天每周每月按设置的次数弹
          if (
            moment(current_time).isSame(
              last_pop_up_time,
              FREQUENCY[frequency]
            ) &&
            times < poster['pop_up_time']
          ) {
            statisticPoster(poster.id, 'element_view')
            return true
          } else {
            return false
          }
        }
      } else {
        //从未弹出过
        statisticPoster(poster.id, 'element_view')
        return true
      }
    } else {
      //原先的弹窗逻辑
      if (
        localStorage.getItem(`poster${poster.id}`) == 1 ||
        !poster.image_path
      ) {
        return false
      }

      statisticPoster(poster.id, 'element_view')
      return true
    }
  }

  goTo = (poster, falg) => {
    const id = poster.id
    if (falg) {
      //上次点击事件
      setCookie(`last_pop_up_time${id}`, moment().format(__FMT1__))
      //点击次数
      let times = getCookie(`click_times${id}`) || 0
      setCookie(`click_times${id}`, +times + 1)
    } else {
      localStorage.setItem(`poster${id}`, 1)
    }
    gotoPoster(poster)
  }

  gotoRightFloat = () => {
    this.goTo(this.rightFloatPoster)
    this.closeRightFloat()
  }

  gotoPopup = () => {
    this.goTo(this.popupPoster, 'specail')
    this.closePopup()
  }

  @action
  closePopup = () => {
    this.popupVisible = false
  }

  @action
  closeRightFloat = () => {
    this.rightFloatVisible = false
  }

  /**
   * 是否存在顶部 banner，存在可能会影响定位
   * 顶部banner有60px高度
   */
  @computed
  get hasBannerPoster() {
    return this.banner.image_path
  }
}

export default Store
